<script setup lang="ts">
const props = defineProps<{ number?: number, placeholder?: string, decimals?: number }>()


function numberWithSpaces(x: number) {
  const decimals = props.decimals || (x % 1 === 0 ? 0 : 2)
  return x.toLocaleString(undefined, {minimumFractionDigits: decimals, maximumFractionDigits: decimals})
}

</script>

<template>
  <span v-if="number !== undefined">
  {{ numberWithSpaces(number) }}
  </span>
  <span v-else>
    {{ placeholder }}
  </span>
</template>
